import Swiper from 'swiper/bundle';

$(document).ready(() => {
    if (jQuery('.news-slider').length) {
        const swiper1 = new Swiper(".site-1 .news-slider", {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 24,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
                1200: {
                    slidesPerView: 3,
                    slidesPerGroup: 3
                }
            }
        });

        const swiper2 = new Swiper(".site-2 .news-slider", {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 24,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
                1200: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 40
                }
            }
        });
    }
});